export default __webpack_public_path__ + "static/media/flag-vanuatu.05090dc3.svg";